import './BackToTop.scss';

import React, { useCallback, useEffect, useState } from 'react';

import Button from '@/common/components/atoms/Button/Button';
import scrollToAnchor from '@/common/helpers/scrollToAnchor';
import { ReactComponent as ArrowIcon } from '@/ebat/assets/icons/chevron-top.svg';

const BackToTop = () => {
  const [isShowButton, setIsShowButton] = useState(false);

  const scrollToTop = useCallback(() => scrollToAnchor('#main-body'), []);

  const toggleShow = useCallback(
    () => setIsShowButton(window.innerHeight < window.scrollY),
    [],
  );

  useEffect(() => {
    window.addEventListener('scroll', toggleShow);

    return () => window.removeEventListener('scroll', toggleShow);
  }, [toggleShow]);

  if (isShowButton) {
    return (
      <div className="back-to-top">
        <Button onClick={scrollToTop} context="back-to-top">
          <ArrowIcon className="button__icon" />
        </Button>
      </div>
    );
  }

  return null;
};

export default BackToTop;
